import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    width: "100%",
    padding: "0",
    overflow: "hidden",
    "> button": {
      cursor: "pointer",
    },
  },
  screen: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    overflow: "hidden",
    minHeight: 0,
  },
});
